import { render, staticRenderFns } from "./TextEditor5.vue?vue&type=template&id=45d91dbf&"
import script from "./TextEditor5.vue?vue&type=script&lang=ts&"
export * from "./TextEditor5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45d91dbf')) {
      api.createRecord('45d91dbf', component.options)
    } else {
      api.reload('45d91dbf', component.options)
    }
    module.hot.accept("./TextEditor5.vue?vue&type=template&id=45d91dbf&", function () {
      api.rerender('45d91dbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/inputs/TextEditor5.vue"
export default component.exports